"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PopupActions;
(function (PopupActions) {
    PopupActions["MANAGE_WALLETS"] = "manage-wallets";
    PopupActions["LINK_WALLET"] = "link-wallets";
    PopupActions["CLAIM_WALLETS"] = "claim-wallets";
})(PopupActions = exports.PopupActions || (exports.PopupActions = {}));
//# sourceMappingURL=PopupActions.js.map